"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function SpaceOfMeanings() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll();
  const noiseTexture = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.05'/%3E%3C/svg%3E")`;
  return <section data-section-id="22235" id="профессиональная-защита-интересов-в-калуге" className="relative min-h-[90vh] w-full overflow-hidden dark bg-background text-foreground flex items-center py-12 lg:py-24">
      {}
      <div className="absolute inset-0 pointer-events-none z-0 opacity-20 mix-blend-multiply" style={{
      backgroundImage: noiseTexture
    }} />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_0.8fr] gap-12 lg:gap-20 items-center">
          {}
          <div ref={imgRef} className={`relative transition-all duration-1000 ease-out ${imgVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="relative w-full aspect-[4/5] max-w-full lg:max-w-2xl overflow-hidden rounded-sm shadow-2xl">
              <img src="https://welcome-husky.10web.cloud/wp-content/uploads/2026/03/my-photo_2026-03-25_11_47_45.jpg" alt="Адвокат Николай Кондрашов" className="w-full h-full object-cover" />
              <div className="absolute -bottom-6 -right-6 md:bottom-10 md:-right-10 bg-card/95 backdrop-blur-md p-6 rounded-sm shadow-2xl border border-border/50 max-w-[220px] hidden md:block">
                <p className="font-mono text-xs uppercase tracking-widest text-secondary mb-2">Стаж работы</p>
                <p className="font-serif italic text-primary text-2xl leading-tight">
                  11+ лет успешной практики
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center space-y-8 transition-all duration-1000 delay-300 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-6">
              <div className="inline-block px-3 py-1 border border-border/50 rounded-sm bg-accent/10">
                <span className="font-mono text-xs uppercase tracking-widest !text-[hsl(210,16%,93%)]">Реестровый номер 40/806</span>
              </div>
              
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-medium text-foreground leading-[1.1] tracking-tight">
                Профессиональная <br />
                <span className="text-primary italic">защита интересов</span>
              </h1>
              
              <div className="w-24 h-1 bg-primary/40 rounded-full" />

              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl font-sans font-light">
                Адвокат Николай Кондрашов. Квалифицированная юридическая помощь в Калуге. 
                Специализируюсь на гражданских делах и корпоративном арбитраже, 
                обеспечивая надежную правовую опору вашему бизнесу и частным интересам.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="rounded-sm px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/ContactPage">
                  Записаться на консультацию
                </Link>
              </Button>
              
              <Button asChild variant="ghost" size="lg" className="rounded-sm px-8 py-6 text-lg hover:bg-accent/20 group border border-border/30">
                <Link to="/ServicesPage">Виды помощи<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/SpaceOfMeanings.tsx|sig:jvxnmr" data-ast-start="4279" data-ast-end="4365"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
            </div>

            {}
            <div className="pt-8 border-t border-border/20 flex items-center gap-8 text-sm text-muted-foreground/80">
              <div className="flex items-center gap-2">
                <span className="block w-2 h-2 rounded-full bg-emerald-500/50" />
                <span className="font-sans">Строгая конфиденциальность</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="block w-2 h-2 rounded-full bg-blue-500/50" />
                <span className="font-sans">Арбитражная практика</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}